import { useState, useEffect, useRef } from 'react'

export function useElementRectById(id: string): DOMRect | null {
  const [rect, setRect] = useState<DOMRect | null>(null)
  const rafRef = useRef<number | null>(null)

  useEffect(() => {
    if (typeof window === 'undefined') return

    const measure = () => {
      const el = document.getElementById(id)

      if (!el) {
        setRect(null)

        return
      }

      const rect = el.getBoundingClientRect()

      setRect(rect)
    }

    measure()

    const handleResize = () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current)
      rafRef.current = requestAnimationFrame(measure)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      if (rafRef.current) cancelAnimationFrame(rafRef.current)
    }
  }, [id])

  return rect
}
